import { initContract } from "@ts-rest/core";
import { SellingPlanGroupApiResponse } from "@smartrr/shared/entities/SellingPlanGroup";

const contractInstance = initContract();

export const sellingPlanGroupsContract = contractInstance.router({
  getSellingPlanGroups: {
    method: "GET",
    path: "/selling-plan-groups",
    responses: {
      200: contractInstance.type<SellingPlanGroupApiResponse[]>(),
    },
  },
});
